import Button  from "@material-ui/core/Button";
import { useCallback, useState } from "react";
import { useLayoutState } from "../../store/LayoutState";


function LayoutBox() {
  const {layout, changeHorizontal, changeVertical, changeMapOnly, changeCrossOnly} = useLayoutState();
  const [open, setOpen] = useState(false);

  const handleOpenDropdown = useCallback(event => {
    const layoutBox = event.target;
    event.preventDefault();
    event.stopPropagation();
    if (!open) {
      setOpen(true);
      const closePreference = () => {
        layoutBox.removeEventListener('click', closePreference);
        document.removeEventListener('click', closePreference);
        setTimeout(() => {
          setOpen(false);
        })
      };
      layoutBox.addEventListener('click', closePreference);
      document.addEventListener('click', closePreference);
    } else {
      setOpen(false);
    }
  }, [open]);

  const dropOpen = open ? 'open' : '';

  return (
    <>
      <Button style={{textTransform:'none'}} onClick={handleOpenDropdown}>
        <div className="header-item">
          <div className={`layout-icon ${layout}`} />
          <span className="header-item-label layout">Layout</span>
        </div>
      </Button>
      <div className={`layout-box ${dropOpen}`}>
        <dl className="dropdown-menu">
          <dt>
            <div className="layout-icon horizontal" onClick={changeHorizontal}/>
          </dt>
          <dd onClick={changeHorizontal}>Horizontal split</dd>
          <dt>
            <div className="layout-icon vertical" onClick={changeVertical}/>
          </dt>
          <dd onClick={changeVertical}>Vertical split</dd>
          <dt>
            <div className="layout-icon map-only" onClick={changeMapOnly}/>
          </dt>
          <dd onClick={changeMapOnly}>Map</dd>
          <dt>
            <div className="layout-icon cross-only" onClick={changeCrossOnly}/>
          </dt>
          <dd onClick={changeCrossOnly}>Cross section</dd>
        </dl>
      </div>
    </>
  );
}
export default LayoutBox;